import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BankIdPollingService, ClientInfoDataSourceService, SithsEIDPollingService } from './datasource';
import { AuthenticationService, BankIdService, SithsEIDService, ThemeService, TotpService } from './api';
import { AuthenticationContextDatasourceService } from './datasource/authentication-context-datasource.service';
import { FrejaEidService } from './api/freja-eid.service';
import { FrejaEidOrgService } from './api/freja-org.service';
import { FrejaEidPollingService } from './datasource/freja-eid-polling.service';
import { FrejaEidOrgPollingService } from './datasource/freja-org-polling.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    AuthenticationService,
    SithsEIDService,
    SithsEIDPollingService,
    BankIdService,
    BankIdPollingService,
    FrejaEidService,
    FrejaEidOrgService,
    FrejaEidPollingService,
    FrejaEidOrgPollingService,
    ClientInfoDataSourceService,
    AuthenticationContextDatasourceService,
    TotpService,
    ThemeService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class BackendModule {}
